const Vue = require('vue');

Vue.component('form-boolean', {
    props: {
        name: {
            default: null
        },
        label: {
            twoWay: true,
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        compact: {
            default: false
        },
        trueLabel: {
            default: "Sim"
        },
        falseLabel: {
            default: "Não"
        },
        placeholder: {
            default: 'Selecione...'
        },
        disabled: {
            default: false
        }
    },
    data() {
        return {
            fieldName: ""
        }
    },
    ready() {
        this.fieldName = this.name || this._props.model.raw
    },
    template: `
            <div class="form-group" v-bind:class="{'form-group-compact': compact}">
                <label v-if="label">{{ label }}</label>
                <select v-model="model" class="form-control" v-bind:data-field="fieldName" :disabled="disabled">
                    <option v-if="model !== true && model !== false" v-bind:value="null" disabled>{{ placeholder }}</option>
                    <option v-bind:value="true">{{trueLabel}}</option>
                    <option v-bind:value="false">{{falseLabel}}</option>
                </select>
            </div>
        `
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/boolean.js